import { UserRoles } from './UserRoles';

export class StudentData {

  public  crNs:Array<string>;
  public  branch:string;
  public  program:string;
  public  faculty:string;
  public  userName:string;
  public  firstName:string;
  public  lastName:string;

}